module.exports = __webpack_public_path__ + "img/home_head_md.d7aa8229.png";